import { FloatingPrefixInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useForm } from "react-hook-form"
import { useLostPasswordRequest } from '../../services/Login';
import { useEffect } from "react";
import { useTrads } from "../../contexts/trads/useTrads";

interface LostPasswordData{
    email:string;
}

function LostPassword(){
    const { register,handleSubmit, formState: { errors }  } = useForm({
        defaultValues:{email:""} as LostPasswordData,
        shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {result,lostPasswordRequest}=useLostPasswordRequest();
    const  onSubmit = (data:LostPasswordData) => {
        lostPasswordRequest(data.email)
    }
    const {translate}=useTrads();
    useEffect(() => {
        return () => {
            result.isSuccess=false;
            result.isLoading=false;
            result.error=null;
            result.data=null;
        };
    }, [result]);
    return (
        result.isSuccess ? <p className="p-3 mb-2 bg-success text-white">{translate("lost_page_success")}</p> : (
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate("page_load_error")}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate("page_loading")}</p> :
        
            (

                <form className="row align-items-center" onSubmit={(event) => void handleSubmit(onSubmit)(event)}>
                    <div className="col-auto  mb-3">
                        <FloatingPrefixInputBootStrap
                            name="email"
                            label={translate('form_email_label')}
                            type="email"
                            prefix="@"
                            errors={errors}
                            registerOutput= {register("email", {
                                required: translate('email_required'),
                                minLength: 2
                            })} 
                            rest={{"autoComplete" : "email"}}
                        />
                    </div>
                    <div className="col-auto  mb-3">
                        <button type="submit">{translate('form_submit')}</button>
                    </div>
                </form>

            )
        )
    )

}
export default LostPassword;